import { NavLink } from "react-router-dom"
import Hero from './Hero';
import Hero_1 from './Hero_1';
import Video from './Video';
import Drpart from './Drpart';
import Cityservice from './Cityservice';
import Services from './Services';
import { Routes, Route } from 'react-router-dom';
import ServicesSection from "./ServicesSection";
import PetServices from "./PetServices";

function App() {
  return (
    <div>
    
     <Hero/>
     {/* <Services/> */}
     <ServicesSection/>
     <Hero_1/>
     <Video/>
     <Drpart/>
     <Cityservice/>
     
    
     {/* <Body/> */}
    </div>
  );
}

export default App;
